export default {
  "global": {
    "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["OHO"])}
  }
}